// TODUE V2 — profil predajcu (seller, EN16931 BG-4). AC8.
// Žije v Dexie `settings` store (key 'v2_seller_profile'). Default prázdny objekt —
// faktúra sa vystaví aj bez údajov predajcu (snapshot = prázdne polia). Editačné
// UI = Wave 1 (Q2 default: prázdny OK, bez UI).
//
// 0 fetch / 0 Supabase / 0 auth / 0 LLM — čistá lokálna Dexie operácia.
//
// initV2() na začiatku get/set: V2 engine je lazy singleton. SettingsV2 stránka
// (kde sa profil edituje) initV2 pre profil sama NEVOLÁ, takže musí byť
// self-sufficient — inak reálny OPFS get/put hodí „engine nie je otvorený" a
// profil sa ticho stratí (jsdom testy to nechytia — engine majú vždy otvorený).
// Rovnaký vzor ako vatStatus.js / szcoStatus.js. initV2 je idempotentný.
import { db, putSetting, initV2 } from './db';

export const SELLER_PROFILE_KEY = 'v2_seller_profile';

// Prázdny profil — všetky EN16931 BG-4 polia ako '' (nie null), aby snapshot
// na faktúre mal konzistentný tvar.
export function emptySellerProfile() {
  return {
    name: '', ico: '', dic: '', ic_dph: '', address: '', iban: '',
    // Rozšírené polia (zrkadlia prod workspace profil firmy). Banka/bic idú na
    // platobný riadok faktúry, kontakt (email/phone/web) do hlavičky, type/register
    // do pätičkových údajov. Všetko '' default → snapshot faktúry má stabilný tvar.
    bank: '', bic: '', email: '', phone: '', web: '', business_register: '', type: '',
  };
}

// Prečíta uložený profil predajcu. Chýbajúci/poškodený → prázdny profil (nikdy crash).
export async function getSellerProfile() {
  try {
    await initV2();
    const row = await db.settings.get(SELLER_PROFILE_KEY);
    const p = row?.value;
    if (!p || typeof p !== 'object') return emptySellerProfile();
    return { ...emptySellerProfile(), ...p };
  } catch (e) {
    console.warn('[v2] getSellerProfile failed, fallback empty', e);
    return emptySellerProfile();
  }
}

// Uloží profil predajcu (merge nad prázdny tvar). Vracia uložený profil.
export async function setSellerProfile(profile) {
  await initV2();
  const value = { ...emptySellerProfile(), ...(profile || {}) };
  await putSetting({ key: SELLER_PROFILE_KEY, value });
  return value;
}
